<template>
  <el-card shadow="never">
    <div style="font-size: 14px; font-weight: bold; margin-bottom: 5px">
      环境参数
    </div>
    <div v-if="!newDate">暂无数据</div>
    <el-row :gutter="2" style="padding: 8px">
      <el-col :span="6">
        <span class="land-env-lbl"> 空气湿度:</span>
        <span class="land-env-val">{{ equips.airh }}</span>
        <span class="land-env-unit">%RH</span>
      </el-col>
      <el-col :span="6">
        <span class="land-env-lbl">空气温度:</span
        ><span class="land-env-val"> {{ equips.airt }}</span>
        <span class="land-env-unit">°C</span>
      </el-col>
      <el-col :span="6">
        <span class="land-env-lbl">二氧化碳浓度:</span
        ><span class="land-env-val">{{ equips.co2 }}</span>
        <span class="land-env-unit">ppm</span>
      </el-col>
      <el-col :span="6">
        <span class="land-env-lbl">光照强度:</span
        ><span class="land-env-val">{{ equips.illu }}</span>
        <span class="land-env-unit">Lux</span>
      </el-col>
    </el-row>
    <el-row :gutter="2" style="padding: 8px">
      <el-col :span="6">
        <span class="land-env-lbl">土壤电导率:</span>
        <span class="land-env-val">{{ equips.soilec }}</span>
        <span class="land-env-unit">μs/cm</span>
      </el-col>
      <el-col :span="6">
        <span class="land-env-lbl">土壤湿度:</span
        ><span class="land-env-val">{{ equips.soilh }}</span>
        <span class="land-env-unit">%RH</span>
      </el-col>
      <el-col :span="6">
        <span class="land-env-lbl">土壤酸碱度:</span>
        <span class="land-env-val">{{ equips.soilph }}</span>
      </el-col>
      <el-col :span="6">
        <span class="land-env-lbl">土壤温度:</span
        ><span class="land-env-val">{{ equips.soilt }}</span>
        <span class="land-env-unit">°C</span>
      </el-col>
    </el-row>
    <div>
      <el-row :gutter="20" style="margin-top: 16px">
        <el-col :span="12">
          <div id="templature" ref="templature" style="height: 200px"></div>
        </el-col>
        <el-col :span="12">
          <div id="soilh" ref="soilh" style="width: 100%; height: 200px"></div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div
            id="soilec"
            ref="soilec"
            style="width: 100%; height: 200px"
          ></div>
        </el-col>
        <el-col :span="12">
          <div id="co2" ref="co2" style="width: 100%; height: 200px"></div>
        </el-col>
      </el-row>
    </div>
  </el-card>
</template>

<script>
import * as echarts from 'echarts'
import { searchUrl, getEquipData } from '@/api/equipControl.js'
export default {
  name: 'MonitorDemo',
  props: ['sn'],
  data() {
    return {
      baseUrl: null,
      flag: false,
      equips: {
        airh: '',
        airt: '',
        co2: '',
        illu: '',
        soilec: '',
        soilh: '',
        soilph: '',
        soilt: '',
      },
      display: false,
      titleOption: [
        {
          code: 'airh',
          label: '空气湿度',
        },
        {
          code: 'airt',
          label: '空气温度',
        },
        {
          code: 'co2',
          label: '二氧化碳浓度',
        },
        {
          code: 'illu',
          label: '光照强度',
        },
        {
          code: 'soilec',
          label: '土壤导电率',
        },
        {
          code: 'soilh',
          label: '土壤湿度',
        },
        {
          code: 'soilph',
          label: '土壤酸碱度',
        },
        {
          code: 'soilt',
          label: '土壤温度',
        },
      ],
      airtArr: [],
      soiltArr: [],
      historyData: [],
      airhArr: [],
      co2Arr: [],
      illuArr: [],
      soilecArr: [],
      soilhArr: [],
      soilphArr: [],
      time: undefined,
      newDate: true,
      outEquip: {},
    }
  },
  filters: {
    valueFormat(val) {
      let obj = JSON.parse(val)
      return obj.value + obj.unit
    },
    codeFormat(val, titleOption) {
      let obj = titleOption.find((item) => item.code == val)
      return obj.label
    },
  },
  computed: {
    apiBaseUrl() {
      return process.env.IOT_BASE_URL
    },
  },
  mounted() {},
  methods: {
    getUrl() {
      // console.log('aa', this.sn)
      if (!this.sn) {
        Object.keys(this.equips).forEach((item) => {
          this.equips[item] = ''
        })
        return
      }
      searchUrl(this.sn).then((res) => {
        console.log('获取地址', res)
        if (res.data != null) {
          this.baseUrl =
            'http://' + res.data.domain + '/api/realtime/' + this.sn
          console.log('this.baseUrl', this.baseUrl)
          this.equipDataGet()
        }
      })
    },
    equipData() {
      getEquipData(this.baseUrl).then((res) => {
        console.log('室内设备', res)
        if (res.data.deviceData) {
          this.equips = res.data.deviceData
          console.log('室内设备', this.equips)
        } else {
          Object.keys(this.equips).forEach((item) => {
            this.equips[item] = ''
          })
        }
      })
    },
    historyDataGet() {
      this.airtArr = []
      this.soiltArr = []
      this.airhArr = []
      this.historyData = []
      this.co2Arr = []
      this.illuArr = []
      this.soiltArr = []
      this.soilhArr = []
      this.soilphArr = []
      this.soilphArr = []
      console.log('mmm', this.apiBaseUrl)
      this.$http
        .get(`${this.apiBaseUrl}/history/24/${this.sn}`, {})
        .then((data) => {
          console.log('zzz', data)
          data.data.data.forEach((item) => {
            this.historyData.push(new Date(item.createTime).format('hh:mm'))
            this.airtArr.push(item.deviceData.airt)
            this.airhArr.push(item.deviceData.airh)
            this.co2Arr.push(item.deviceData.co2)
            this.illuArr.push(item.deviceData.illu)
            this.soilecArr.push(item.deviceData.soilec)
            this.soilhArr.push(item.deviceData.soilh)
            this.soilphArr.push(item.deviceData.soilph)
            this.soiltArr.push(item.deviceData.soilt)
          })

          this.doubleLineget(
            this.airtArr,
            this.soiltArr,
            '空气温度',
            '土壤温度',
            '°C',
            '°C',
            'templature',
            'red'
          )
          this.doubleLineget(
            this.co2Arr,
            this.illuArr,
            '二氧化碳浓度',
            '光照强度',
            'ppm',
            'Lux',
            'co2'
          )
          this.doubleLineget(
            this.soilecArr,
            this.soilphArr,
            '土壤电导率',
            '土壤酸碱度',
            'μs/cm',
            '',
            'soilec'
          )
          this.doubleLineget(
            this.airhArr,
            this.soilhArr,
            '空气湿度',
            '土壤湿度',
            '%RH',
            '%RH',
            'soilh',
            'red'
          )
        })
    },
    doubleLineget(arrleft, arrRight, name1, name2, unit1, unit2, dom, color) {
      let myChart = echarts.getInstanceByDom(this.$refs[dom])
      if (myChart == null) {
        // 如果不存在，就进行初始化
        myChart = echarts.init(this.$refs[dom])
      }
      var option
      option = {
        grid: {
          top: 40,
          bottom: 40,
          width: '75%',
          left: '12%',
        },
        title: {
          text: '空气温湿度监测',
          show: false,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: {},
        toolbox: {
          show: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.historyData,
        },
        yAxis: [
          {
            type: 'value',
            position: 'left',
            axisLabel: {
              formatter: '{value}' + unit1,
            },
          },
          {
            type: 'value',
            position: 'right',
            axisLabel: {
              formatter: '{value} ' + unit2,
            },
          },
        ],
        series: [
          {
            name: name1,
            type: 'line',
            data: arrleft,
            yAxis: 1,
          },
          {
            name: name2,
            type: 'line',
            data: arrRight,
            yAxisIndex: 1,
            lineStyle: {
              color: color,
            },
            color: color,
            // itemStyle:{normal:{color:'#d14a61'}},
          },
        ],
      }
      option && myChart.setOption(option)
    },
    equipDataGet() {
      if (this.time) {
        clearInterval(this.time)
      }
      this.equipData()
      this.historyDataGet()
      this.time = setInterval(() => {
        this.historyDataGet()
        this.equipData()
      }, 60000)
    },
  },
  beforeDestroy() {
    clearInterval(this.time)
  },
}
</script>

<style scoped>
.land-env-lbl {
  display: inline-block;
  width: 80px;
  font-size: 12px;
  color: #666;
}
.land-env-val {
  display: inline-block;
  width: 60px;
  background-color: #095933;
  font-size: 15px;
  color: #fff;
  text-align: right;
  padding: 2px;
  border-radius: 4px;
}
.land-env-unit {
  font-size: 10px;
  color: #9f9f9f;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/environment/MonitorData.vue